export const createDefaultDto = () => {
    let userInfo = {
        mobile: "",
        email: "",
        firstName: "",
        lastName: ""
    };
    return { userInfo: userInfo, loginUserType: LoginUserType.Unknown, access: [] };
};
export class UserDto {
}
export class UserInfoDto {
}
export var LoginUserType;
(function (LoginUserType) {
    LoginUserType[LoginUserType["Unknown"] = 0] = "Unknown";
    LoginUserType[LoginUserType["SupportFull"] = 1] = "SupportFull";
    LoginUserType[LoginUserType["SupportOffices"] = 2] = "SupportOffices";
    LoginUserType[LoginUserType["SalesFull"] = 3] = "SalesFull";
    LoginUserType[LoginUserType["SalesOffices"] = 4] = "SalesOffices";
    LoginUserType[LoginUserType["Client"] = 5] = "Client";
    LoginUserType[LoginUserType["FeedProvider"] = 6] = "FeedProvider";
})(LoginUserType || (LoginUserType = {}));
export var EntryTypeDto;
(function (EntryTypeDto) {
    EntryTypeDto[EntryTypeDto["Agency"] = 1] = "Agency";
    EntryTypeDto[EntryTypeDto["Office"] = 2] = "Office";
})(EntryTypeDto || (EntryTypeDto = {}));
export var RoleDto;
(function (RoleDto) {
    // Brand level
    RoleDto[RoleDto["Brand"] = 1] = "Brand";
    // Office level
    RoleDto[RoleDto["Principal"] = 10] = "Principal";
    RoleDto[RoleDto["Admin"] = 11] = "Admin";
    // Agent level
    RoleDto[RoleDto["Agent"] = 20] = "Agent";
    // Internal Sales
    RoleDto[RoleDto["SalesManager"] = 30] = "SalesManager";
    RoleDto[RoleDto["RegionalAccountManager"] = 31] = "RegionalAccountManager";
    RoleDto[RoleDto["AccountManager"] = 32] = "AccountManager";
    // Internal Support
    RoleDto[RoleDto["SupportManager"] = 40] = "SupportManager";
    RoleDto[RoleDto["Support"] = 41] = "Support";
})(RoleDto || (RoleDto = {}));
